import { styled } from '@mui/material';

 import { Typography, Box } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { ResultsTooltip } from './ResultsTooltip';

const StyledText = styled(Typography)(() => ({
  color: 'var(--text-text-secondary-color)',
  fontSize: 13,
  width: '100%',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  flex: 1,
  flexDirection: 'row',
}));

export const ResultsFooter = () => {
  const { t } = useI18n();

  return (
    <StyledBox>
      <StyledText>
        {t('shared:results_footer.text')}
      </StyledText>
      <ResultsTooltip/>
    </StyledBox>
  )
};
